import cn from 'classnames';
import { useEffect } from 'react';
import { withBaseErrorBoundary } from '@components/error-boundaries';
import { setWidgetIframeHeight } from '@utils/parant-site-comunicator';
import { SignupBody } from './signup-body';
import { SignupFooter } from './signup-footer';
import { signUpId } from '../helpers';

import styles from '../auth-page.module.scss';

export const SignupPage = withBaseErrorBoundary(() => {
    useEffect(() => {
        setTimeout(() => {
            setWidgetIframeHeight('default');
        }, 500);
    });

    return (
        <div id={signUpId('page')} className={styles.layout}>
            <div className="container">
                <div className={cn('rounded-box', styles.box)}>
                    <SignupBody />
                    <SignupFooter type="page" />
                </div>
            </div>
        </div>
    );
});
